import { createStore } from 'vuex'
import app from './app'
import sectionTypes from './sectionTypes'
import settings from './settings'
import user from './user'
import users from './users'
import dictionary from './dictionary'
import desks from './desks'

import createPersistedState from 'vuex-persistedstate'

const store = createStore({
  modules: {
    app, sectionTypes, settings, user, users, dictionary, desks
  },
  plugins: [createPersistedState()],
})

export default store
